<template>
  <router-view />
</template>

<script lang="ts">
// Components
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',

  async created () {
    document.title = 'Проверка документа'
  },
});
</script>

<style scoped>

</style>
